import type { TokenData } from "@/common/types/chat.types";
import config from "./config";
import theme from "./theme";
import { createRoot } from "react-dom/client";
import { getLongLivedTokenObject } from "@/common/utils";
import { AzureAuthProvider, useAzureAuth } from "@/common/components/AzureAuthProvider";
import { getAuthConfig } from "../../common/authConfig";
import App from "@/common/App";
import MsAuthenticationService from "@/common/services/MsAuthenticationService";

export default function main(
  container: HTMLElement,
  options?: {
    getToken?: () => Promise<TokenData>;
    startLogin?: () => Promise<void>;
  },
) {
  const authConfig = getAuthConfig();
  const authService = new MsAuthenticationService(authConfig.clientId, authConfig.authority);

  // Use long-lived token for backend Authorization header
  const getToken = async (): Promise<TokenData> => {
    return getLongLivedTokenObject();
  };

  // Component to bridge Azure auth context to App props
  const AppWithAuth = () => {
    const { getEntraToken, startLogin: authStartLogin } = useAzureAuth();
    
    return (
      <App
        config={config}
        getToken={options?.getToken || getToken}
        getEntraToken={getEntraToken}
        startLogin={authStartLogin}
      />
    );
  };

  const root = createRoot(container);
  root.render(
    <div style={theme as React.CSSProperties}>
      <AzureAuthProvider authService={authService}>
        <AppWithAuth />
      </AzureAuthProvider>
    </div>,
  );

  return root;
}
